import React from "react";

import * as styles from "./styles/card-container.module.scss";

const CaseStudyCardContainer = ({
    children
}) => {
    return (
        <section className={styles.cardContainer}>
            {children}
        </section>
    )
}

export default CaseStudyCardContainer;